import type { ReactNode } from 'react';
import { Text } from '@mentimeter/ragnar-ui/text';

export function Strong(chunks: ReactNode) {
  return <Text fontWeight="semiBold">{chunks}</Text>;
}
